const pageUtilities = require('../utilities/pageUtilities');

/**
 * Get original element data attributes and set in new element
 * @param {jQuery} originalElement Original
 * @param {jQuery} newElement New
 */
function cloneDataAttributes(originalElement, newElement) {
    const data = originalElement.data();
    Object.keys(data).forEach(function (key) {
        var attrName = 'data-' + key.replace(/[A-Z]/g, function ($0) {
            return '-' + $0.toLowerCase();
        });
        newElement.attr(attrName, data[key]);
    });
}

/**
 * Check if last units alert message must be shown
 * @param {jQuery} $option Current select option element
 * @param {jQuery} $lastUnitsAlertMessage last Units Alert Message element
 * @return {boolean} True if message must be shown
 */
function showLastUnitsAlertMessage($option, $lastUnitsAlertMessage) {
    return $option.hasClass('stock-last-units')
        && $lastUnitsAlertMessage.length > 0
        && !pageUtilities.isQuickView($option)
        && (pageUtilities.isQuickShop($option) || pageUtilities.isProductDetailPage());
}

/**
 * Check if stock alert modal link must be shown
 * @param {jQuery} $option Current select option element
 * @param {jQuery} $stockAlertModalLink stock Alert Modal Link element
 * @return {boolean} True if link must be shown
 */
function mustShowStockAlertModalLink($option, $stockAlertModalLink) {
    return $option.hasClass('disabled--unavailable')
        && $stockAlertModalLink.length > 0
        && !pageUtilities.isQuickView($option)
        && (pageUtilities.isQuickShop($option) || pageUtilities.isProductDetailPage());
}

/**
 * Return a customOptionElement according to the original $option
 * @param {jQuery} $option The original <option> element to process.
 * @param {boolean} isSelected Whether this option matches the current selected value.
 * @returns {jQuery|null} A jQuery element, or null.
 */
function createOption($option, isSelected) {
    const hide = $option.data('hide');
    if (hide === true || hide === 'true') {
        return null;
    }

    const isQuickShop = pageUtilities.isQuickShop($option);
    const isDisabledUnavailable = $option.hasClass('disabled--unavailable');
    let classSelected = '';
    let classDisabled = '';
    let selectOptionClasses = '';

    if (isSelected) {
        classSelected = 'selected';
    }

    if ($option.attr('class')) {
        selectOptionClasses = $option.attr('class').split(/\s+/).toString().replace(',', ' ');
    }

    if ($option.attr('disabled')) {
        classDisabled = 'disabled';
    }

    var $customOption = $('<button />', {
        html: '<span class="product-sizes__value">' + $option.text() + '</span>',
        rel: $option.val(),
        role: 'option',
        'aria-selected': !!selectOptionClasses,
        tabindex: isQuickShop || isDisabledUnavailable ? '-1' : '0',
        class: classDisabled
            + ' '
            + classSelected
            + ' '
            + selectOptionClasses
    });

    cloneDataAttributes($option, $customOption);

    const $stockAlertModalLink = $('.stock-alert-modal-link').first();
    const $lastUnitsAlertMessage = $('.product-info__last-units').first();
    if (mustShowStockAlertModalLink($option, $stockAlertModalLink)) {
        const stockAlertModalLinkClone = $stockAlertModalLink.clone();
        stockAlertModalLinkClone.removeClass('d-none');
        if (isQuickShop) {
            stockAlertModalLinkClone.attr('tabindex', '-1');
        }
        stockAlertModalLinkClone.appendTo($customOption);
        $customOption.attr('aria-disabled', 'true');
    } else if (showLastUnitsAlertMessage($option, $lastUnitsAlertMessage)) {
        $lastUnitsAlertMessage.clone().removeClass('d-none').appendTo($customOption);
    }

    return $customOption;
}

/**
 * Update $customizedSelect options according to the original $select
 * @param {jQuery} $customizedSelect Customized select object
 * @param {jQuery} $select Original select object
 */
function updateSelectElement($customizedSelect, $select) {
    const numberOfOptions = $select.children('option').length;
    const customizedSelectOptionClasses = $customizedSelect.children('.product-sizes__option')
        .attr('class')
        .replace('stock-last-units', '')
        .replace('disabled--unavailable', '')
        .replace('disabled', '')
        .replace('selected', '');

    $customizedSelect.empty();

    for (var i = 0; i < numberOfOptions; i++) {
        const $option = $select.children('option').eq(i);
        const isSelected = $option.val() === $select.val();
        const $customOption = createOption($option, isSelected);
        if ($customOption) {
            $customOption.appendTo($customizedSelect);
        }
    }

    var $customizedSelectOptions = $customizedSelect.children();
    $customizedSelectOptions.addClass(customizedSelectOptionClasses);

    if (!$select.hasClass('disable-custom-select-listener')) {
        $customizedSelectOptions.click(function (e) {
            if ($(this).hasClass('disabled--unavailable')) {
                return;
            }

            e.stopPropagation();

            if (!$(this).hasClass('disabled')) {
                $customizedSelectOptions.removeClass('selected');
                $customizedSelectOptions.attr('aria-selected', false);
                $(this).addClass('selected');
                $(this).attr('aria-selected', true);
                $select.val($(this).attr('rel'));
                $select.trigger('change');
            }
        });
    }
}

/**
 * Observe DOM mutations on the select options and revert style modifications when any changes.
 * @param {Node} selectContainer - Customized select parent node
 * @param {Function} onChange - Callback to execute when relevant mutations occur.
 */
const onSelectOptionsChange = (selectContainer, onChange) => {
    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationsList, observer) => {
        const hasSelectChanged = mutationsList.some(({ target }) => {
            const tag = target.tagName?.toLowerCase();
            return tag === 'select' || tag === 'option';
        });

        if (!hasSelectChanged) return;

        observer.disconnect();
        onChange();
        observer.observe(selectContainer, config);
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    // Start observing the target node for configured mutation
    observer.observe(selectContainer, config);
};

/**
 * Update customized select options when original select has changed
 * @param {jQuery} [element] - Optional, select element to customize.
 */
function customizeSelects(element) {
    var elements = element || $('.customized-select');

    elements.each((index, value) => {
        var $customizedSelect = $(value);
        var $select = $customizedSelect.siblings('select');

        if ($select.hasClass('force-initial-select')) {
            $select.removeClass('force-initial-select');
            $select.trigger('change');

            // Fix for Bundles. TODO refactor
            if ($customizedSelect.hasClass('isBundle')
                && $select.find('option:selected').hasClass('disabled--unavailable')
            ) {
                var $productContainer = $customizedSelect.closest('.bundled-product');
                $productContainer.find('.bundled-product-input')
                    .attr('disabled', true);
                $productContainer.find('.edit-icon').addClass('disabled');
                $productContainer.addClass('disabled');
            }
        } else {
            updateSelectElement($customizedSelect, $select);
        }

        if (!$select.hasClass('disable-custom-select-listener')) {
            onSelectOptionsChange($select[0].parentNode, function () {
                updateSelectElement($customizedSelect, $select);
            });
        }
    });
}

module.exports = {
    customizeSelects: customizeSelects
};
